import React, { useEffect, useState } from 'react';
import scannerApi from './scannerApi';
import { STATUS_TEXT } from './ScanPage';

// This guard's own scans, newest first (the server filters by the logged-in user).
const HistoryPage = () => {
  const [state, setState] = useState({ rows: [], page: 0, totalPages: 1, total: 0, loading: true });

  const load = async (page) => {
    setState((s) => ({ ...s, loading: true }));
    try {
      const { data } = await scannerApi.get('/handover/scan-log', { params: { page, limit: 20 } });
      setState((s) => ({
        rows: page === 1 ? data.data : [...s.rows, ...data.data],
        page,
        totalPages: data.totalPages,
        total: data.totalItems,
        loading: false,
      }));
    } catch {
      setState((s) => ({ ...s, loading: false }));
    }
  };

  useEffect(() => {
    load(1);
  }, []);

  return (
    <div className="card">
      <div className="card-header py-2 small text-muted">{state.total} scans recorded under your login</div>
      <ul className="list-group list-group-flush">
        {state.rows.map((r) => (
          <li key={r.id} className="list-group-item d-flex justify-content-between align-items-start gap-2" style={r.voided ? { opacity: 0.5, textDecoration: 'line-through' } : undefined}>
            <div>
              <div className="fw-bold">{r.name || `Unknown (${r.reason || r.status})`}</div>
              {r.place && (
                <div className="small">
                  {r.direction ? <strong>{r.direction.toUpperCase()}</strong> : null}{r.direction ? ' · ' : ''}{r.place}{r.voided ? ' (undone)' : ''}
                </div>
              )}
              <div className="small text-muted">
                {r.user_type ? `${r.user_type} · ` : ''}#{r.registration_data_id ?? '—'} · {new Date(r.scanned_at).toLocaleString()}
              </div>
              {r.reason && <div className="small">{r.reason}</div>}
            </div>
            <span className={`badge ${r.allowed ? 'bg-success' : 'bg-danger'}`}>{STATUS_TEXT[r.status] || r.status}</span>
          </li>
        ))}
        {!state.loading && !state.rows.length && <li className="list-group-item text-muted">No scans yet.</li>}
      </ul>
      {state.page < state.totalPages && (
        <button className="btn btn-link" disabled={state.loading} onClick={() => load(state.page + 1)}>
          {state.loading ? 'Loading…' : 'Load more'}
        </button>
      )}
    </div>
  );
};

export default HistoryPage;
